import { render, staticRenderFns } from "./SidebarEditPICBranch.vue?vue&type=template&id=3e96f9ea"
import script from "./SidebarEditPICBranch.vue?vue&type=script&lang=js"
export * from "./SidebarEditPICBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports